
app.controller('managementReportCtrl', function ($rootScope, $scope, $state, urlServices, $filter, toaster,shareData, _VAR_GLOBAL, $uibModal,_API_URL, $window) {

    $scope.reportLoading = false;

    var navigateWithLoading = function (targetUrl) {
        $scope.reportLoading = true;
        $window.location.href = targetUrl;
    };

    var navigateWithoutLoading = function (targetUrl) {
        $scope.reportLoading = false;
        $window.location.href = targetUrl;
    };

    var decodeUrlParam = function (value) {
        if (!value) {
            return value;
        }
        try {
            return decodeURIComponent(value);
        } catch (e) {
            return value;
        }
    };

    var reportError = decodeUrlParam(urlServices.getUrlParameter('report_error'));
    var reportName = decodeUrlParam(urlServices.getUrlParameter('report_name')) || 'Report';
    if (reportError) {
        toaster.pop('error', reportName, reportError);
    }

    $scope.exportProfitLoss = function () {
        var startMonth = urlServices.getUrlParameter('start_month');
        var endMonth = urlServices.getUrlParameter('end_month');
        var year = urlServices.getUrlParameter('year');
        if (!startMonth || !endMonth || !year) {
            return toaster.pop('error', 'Profit & Loss', 'Pilih periode terlebih dahulu');
        }
        navigateWithoutLoading('/report-income-statement?start_month=' + startMonth + '&end_month=' + endMonth + '&year=' + year + '&isexcel=true');
    };

    $scope.exportBalanceSheet = function () {
        var startMonth = urlServices.getUrlParameter('start_month');
        var endMonth = urlServices.getUrlParameter('end_month');
        var year = urlServices.getUrlParameter('year');
        if (!startMonth || !endMonth || !year) {
            return toaster.pop('error', 'Balance Sheet', 'Pilih periode terlebih dahulu');
        }
        navigateWithoutLoading('/report-balance-sheet?start_month=' + startMonth + '&end_month=' + endMonth + '&year=' + year + '&isexcel=true');
    };

    $scope.exportBalanceSheetAudit = function () {
        var startMonth = urlServices.getUrlParameter('start_month');
        var endMonth = urlServices.getUrlParameter('end_month');
        var year = urlServices.getUrlParameter('year');
        if (!startMonth || !endMonth || !year) {
            return toaster.pop('error', 'Audit Selisih Neraca', 'Pilih periode terlebih dahulu');
        }
        navigateWithoutLoading('/report-balance-sheet-audit?start_month=' + startMonth + '&end_month=' + endMonth + '&year=' + year + '&isexcel=1');
    };

    $scope.exportClosedPeriodAudit = function () {
        var startMonth = urlServices.getUrlParameter('start_month');
        var endMonth = urlServices.getUrlParameter('end_month');
        var year = urlServices.getUrlParameter('year');
        if (!startMonth || !endMonth || !year) {
            return toaster.pop('error', 'Audit Perubahan Setelah Tutup Periode', 'Pilih periode terlebih dahulu');
        }
        navigateWithoutLoading('/report-closed-period-audit?start_month=' + startMonth + '&end_month=' + endMonth + '&year=' + year + '&isexcel=1');
    };

    $scope.exportGeneralLedger = function () {
        var startDate = urlServices.getUrlParameter('start_date');
        var endDate = urlServices.getUrlParameter('end_date');
        var from = urlServices.getUrlParameter('from');
        var to = urlServices.getUrlParameter('to');
        if (!startDate || !endDate) {
            return toaster.pop('error', 'General Ledger', 'Pilih periode terlebih dahulu');
        }
        var targetUrl = '/report-general-ledger?start_date=' + startDate + '&end_date=' + endDate + '&isexcel=true';
        if (from && to) {
            targetUrl += '&from=' + from + '&to=' + to;
        }
        navigateWithoutLoading(targetUrl);
    };

    $scope.showMonth=function(typeTrx){
        $scope.typeTrx=typeTrx;
        shareData.setDataDetails($scope.typeTrx)
        $uibModal.open({
            animation: true,
            keyboard: false,
            backdrop: 'static',
            templateUrl: 'modal.confirm.month.html',
            controller: function ($scope, shareData,$window,urlServices, toaster,$uibModalInstance) {
                $scope.params={
                    start_month:new Date().getMonth()+1,
                    end_month:new Date().getMonth()+1,
                    year:new Date().getFullYear()
                };
                $scope.typeTrx=shareData.getDataDetails();
                $scope.close=function(){
                    $uibModalInstance.close();
                }
                $scope.viewReport=function(){
                    if ($scope.params && !$scope.params.end_month && $scope.params.start_month) {
                        $scope.params.end_month = $scope.params.start_month;
                    }
                    if ($scope.params && !$scope.params.year) {
                        $scope.params.year = new Date().getFullYear();
                    }
                    if (($scope.params && !$scope.params.start_month) || !$scope.params.end_month ){
                        return toaster.pop('error','Bulan','Pilih bulan')
                    };
                    
                    switch($scope.typeTrx) {
                        case 'PL':
                                                        navigateWithLoading("/report-income-statement?start_month="+$scope.params.start_month+"&end_month="+$scope.params.end_month+"&year="+$scope.params.year)
                          break;
                        case 'BS':
                                                     navigateWithLoading("/report-balance-sheet?start_month="+$scope.params.start_month+"&end_month="+$scope.params.end_month+"&year="+$scope.params.year)
                          break;
                                                case 'JU':
                                                     navigateWithLoading("/report-unbalanced-journal?start_month="+$scope.params.start_month+"&end_month="+$scope.params.end_month+"&year="+$scope.params.year)
                                                    break;
                        case 'CPA':
                                                     navigateWithLoading("/report-closed-period-audit?start_month="+$scope.params.start_month+"&end_month="+$scope.params.end_month+"&year="+$scope.params.year)
                                                    break;
                          case 'BB':
                                                         navigateWithLoading("/report-general-ledger?start_month="+$scope.params.start_month+"&end_month="+$scope.params.end_month+"&year="+$scope.params.year)
                            break;
                        default:
                          return toaster.pop('error','Report Not Show','Cannot open report')
                      }
                    
                }
                
            }
        });
    };
    $scope.showDate=function(typeTrx){
        $scope.typeTrx=typeTrx;
        shareData.setDataDetails($scope.typeTrx)
        $uibModal.open({
            animation: true,
            keyboard: false,
            backdrop: 'static',
            templateUrl: 'modal.confirm.date.html',
            controller: function ($scope, shareData,$window,$filter,urlServices, toaster,$uibModalInstance,modalFactory) {
                $scope.params={
                    start_date:moment()._d,
                    end_date:moment()._d,
                    showAllAccounts:true
                };
                $scope.setAllAccounts=function(){
                    $scope.params.showAllAccounts=true;
                    $scope.params.kodePerkiraan1='';
                    $scope.params.kodePerkiraan2='';
                };
                $scope.showListCoa=function(isFrom){
                    if ($scope.params.showAllAccounts) {
                        return;
                    }
                    modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
                        functionName: 'coaList',
                        params: {
                            isFrom:isFrom||false
                        }
                    });
                }
                
                $scope.typeTrx=shareData.getDataDetails();
                $scope.close=function(){
                    $uibModalInstance.close();
                };
                $scope.$on('pilih-coa', function (event, args) {
                    console.log('pilih host', args);
                    $scope.params.showAllAccounts=false;
                    if (args.isFrom){
                        $scope.params.kodePerkiraan1=args.coa.KodePerkiraan
                        $scope.params.kodePerkiraan2=args.coa.KodePerkiraan
                    }else{
                        $scope.params.kodePerkiraan2=args.coa.KodePerkiraan
                    }
                    
                    return true;
                    // do what you want to do
                });
                $scope.viewReport=function(){
                    if ($scope.params && !$scope.params.start_date || !$scope.params.end_date ){
                        return toaster.pop('error','Tanggal','Pilih Tangga')
                    };
                    if ($scope.params && $scope.params.start_date._d){
                        $scope.params.start_date=$scope.params.start_date._d;
                    };
                    if ($scope.params && $scope.params.end_date._d){
                        $scope.params.end_date=$scope.params.end_date._d;
                    };
                    switch($scope.typeTrx) {
                       
                          case 'BB':
                            if (!$scope.params.showAllAccounts && $scope.params.kodePerkiraan1){
                                navigateWithLoading("/report-general-ledger?start_date="+$filter('date')($scope.params.start_date, "yyyy-MM-dd")+"&end_date="+$filter('date')($scope.params.end_date, "yyyy-MM-dd")+"&from=" + $scope.params.kodePerkiraan1 + "&to=" + $scope.params.kodePerkiraan2)
                            }else{
                                navigateWithLoading("/report-general-ledger?start_date="+$filter('date')($scope.params.start_date, "yyyy-MM-dd")+"&end_date="+$filter('date')($scope.params.end_date, "yyyy-MM-dd"))
                            }
                             
                            break;
                        default:
                          return toaster.pop('error','Report Not Show','Cannot open report')
                      }
                    
                };

                
                
            }
        });
    };
    $scope.params={
        start_month:urlServices.getUrlParameter('start_month'),
        end_month:urlServices.getUrlParameter('end_month'),
        year:urlServices.getUrlParameter('year')
    }
    $scope.periods={
        text:"Periode : " + $filter('date')(new Date(parseInt($scope.params.year),parseInt($scope.params.start_month)-1,1), "MMMM") + ' - ' + $filter('date')(new Date(parseInt($scope.params.year),parseInt($scope.params.end_month)-1,1), "MMMM") + ' ' + $scope.params.year,
        isSelect:false
    };
    
})
app.controller('managementReportPlCtrl',function($rootScope, $scope, $state, $location, $filter, urlServices, modalService, modalFactory, toaster, _VAR_GLOBAL,$window){
    
    $scope.params={
        start_month:urlServices.getUrlParameter('start_month'),
        end_month:urlServices.getUrlParameter('end_month'),
        year:urlServices.getUrlParameter('year')
    }
    $scope.periods={
        text:"Periode : " + $filter('date')(new Date(parseInt($scope.params.year),parseInt($scope.params.start_month)-1,1), "MMMM") + ' - ' + $filter('date')(new Date(parseInt($scope.params.year),parseInt($scope.params.end_month)-1,1), "MMMM") + ' ' + $scope.params.year,
        isSelect:false
    };
    console.log($scope.periods);
    $scope.viewData=function(){
        
        urlServices.ambilData('api/report/finance/profitloss?start_month='+$scope.params.start_month+'&end_month='+$scope.params.end_month+'&year='+$scope.params.year, {}, function (g, s) {
            console.log(s);
            if (g) {
                if (g && g.err && g.err instanceof Array) {
                    $scope.errorMessage = g.err;
                    var elP = '';
                    for (var key in $scope.errorMessage) {
                        elP += '<p>' + $scope.errorMessage[key].msg + '</p>';
                    }
                    toaster.pop('error', 'Error Data', elP);
                } else {
                    toaster.pop('error', 'Error Data', g.err);
                }
            } else {
                $scope.dataList=s;
               
            }
            // $scope.dataCustomer=args.dt;
        })
        
    };
    // $scope.viewData();


})